export enum StandType {
    Truck = 1,
    Tent = 2,
    Stand = 3,
    Exhibitors = 4,
    Carousels = 5,
}
